<template>
    <div>
        <v-row v-if="ready">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12" md="3">
                        <info v-if="meter && lastReading" :meter="meter" :reading="lastReading"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <value v-if="meter && lastReading" :meter="meter" :reading="lastReading" :prop="'watts'"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <value v-if="meter && lastReading" :meter="meter" :reading="lastReading" :prop="'amps'"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <value v-if="meter && lastReading" :meter="meter" :reading="lastReading" :prop="'volts'"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4" order-md="1" order-lg="1">
                        <mapMeter v-if="meter" :meter="meter"/>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex mx-auto" order-md="3" order-lg="2">
                        <control v-if="meter" :meter="meter"/>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex mx-auto" order-md="2" order-lg="3">
                        <comments :meter="meter"/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="ready" class="mt-n3">
             <v-col cols="12" md="6" > 
                <GraphContainer
                    v-if="meter" 
                    :meter="meter"
                    historic 
                    :graph="new Chart({
                        name: 'KWH month',
                        props: [KWH],
                        type: COLUMS 
                    })"/>
            </v-col> 
            <v-col cols="12" md="6">
                <GraphContainer
                    v-if="meter" 
                    :meter="meter" 
                    :graph="new Chart({
                        name: 'Power (KW)',
                        lines: [LINE1, LINE2, LINE3 ],
                        props: [WATTS],
                        type: LINES
                    })"/>
             </v-col>
             <v-col cols="12" md="6">
                <GraphContainer
                    v-if="meter" 
                    :meter="meter" 
                    :graph="new Chart({
                        name: 'Voltage',
                        props: [VOLTS],
                        lines: [LINE1, LINE2, LINE3 ],
                        type: LINES
                    })"/>
            </v-col>
            <v-col cols="12" md="6">
                <GraphContainer
                    v-if="meter" 
                    :meter="meter" 
                    :graph="new Chart({
                        name: 'Current',
                        lines: [LINE1, LINE2, LINE3 ],
                        props: [AMPS],
                        type: LINES
                    })"/>
            </v-col>
        </v-row>
        <v-row v-if="ready">
            <v-col cols="12">
                <tableReport :meter="meter"/>
            </v-col>
        </v-row>
        <v-row v-else style="height: 100%; position: relative;">
            <v-col align="center" justify="center" style="position: absolute; top: 280px">
                <v-progress-circular
                    class="pcirc"
                    width="5"
                    size="50"
                    indeterminate
                    color="accent"
                ></v-progress-circular>
            </v-col>
        </v-row>
    </div>
</template>


<script>
import { LINE1, LINE2, LINE3 } from '../components/graphs/props-types'
import { WATTS, AMPS, VOLTS, KWH } from '../components/graphs/props-types'
import { COLUMS, LINES } from '../components/graphs/props-types'
import Chart from '../components/graphs/modules/Chart.js'
import tableReport from '../components/Circuit/table'
import control from '../components/Circuit/control'
import mapMeter from '../components/Circuit/map'
import value from '../components/Circuit/value'
import info from '../components/Circuit/info'
import comments from '../components/Circuit/comments'
import { GraphContainer } from "../components/graphs";
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
    name: 'Circuit',
    components: { info, GraphContainer, tableReport, control, mapMeter, value, comments },
    computed: {
        ...mapState({
            lastReading(state){
                if(!state.meters.lastReadings) return{}
                return state.meters.lastReadings.find(m => m ? m.meter === this.$route.params.id: false)
            }
        }),
        ...mapGetters({
            getMeter: "meters/getMeter",
            getLastReading: "meters/getLastReading"
        }),
    },
    data() {
        return {
            Chart,WATTS, AMPS, VOLTS, KWH, COLUMS, 
            LINES,LINE1, LINE2, LINE3,
            ready: false,
            meter: null,
            width: 0
        };
    },
    methods:{
        ...mapActions({ updateMeterFromApi: 'meters/updateMeterFromApi' }),
        async refresh(){
            this.ready = false
            await this.updateMeterFromApi(this.$route.params.id)
            this.meter = this.getMeter(this.$route.params.id)
            if(!this.meter) return this.$router.push({ name: 'Home' })

            if(!this.unSubChange) {
                this.unSubChange = this.$store.subscribe(
                    mutation => {
                        if(mutation.type == 'meters/SET_METER')
                            this.meter = this.getMeter(this.$route.params.id)
                    }
                )
            }
            await this.$store.dispatch('meters/updateMeterData', this.meter.name)
            this.ready = true
        },
        callSB(){
            this.width = this.$root.$children[0].$data.chartWidth
        }
    },
    watch:{
        '$route.params.id'(){
            this.refresh()
        },
    },
    mounted() {
        this.refresh()
        this.callSB()
    },
}
</script>

<style scoped>
</style>